import type { PropsWithChildren } from 'react';
import {
  ViewOptionsSectionBody,
  ViewOptionsSectionContainer,
  ViewOptionsSectionHeader,
  ViewOptionsSectionTitle,
  ViewOptionsSectionTitleContainer,
} from './atoms';

type ViewSettingsSectionProps = PropsWithChildren<{
  title: string;
  ariaLabel: string;
}>;

export const ViewSettingsSection = ({
  title,
  ariaLabel,
  children,
}: ViewSettingsSectionProps) => (
  <ViewOptionsSectionContainer role="region" aria-label={ariaLabel}>
    <ViewOptionsSectionHeader>
      <ViewOptionsSectionTitleContainer>
        <ViewOptionsSectionTitle>{title}</ViewOptionsSectionTitle>
      </ViewOptionsSectionTitleContainer>
    </ViewOptionsSectionHeader>
    <ViewOptionsSectionBody>{children}</ViewOptionsSectionBody>
  </ViewOptionsSectionContainer>
);
